module.exports = __webpack_public_path__ + "img/eat.82ec56b4.png";